import React from 'react';

import { VIEW_TO_PATH } from '../routes';
import { useApp } from '../store/AppContext';
import { NavItem } from './NavItem';

/* Entrée du menu latéral menant à un écran : active quand l'écran est affiché. */
export function ViewNavItem({ view, icon, label, onClick, alert }) {
  const { navigate, sidebarCollapsed, appState } = useApp();
  return (
    <NavItem
      collapsed={sidebarCollapsed}
      icon={icon}
      label={label}
      active={appState.view === view}
      to={VIEW_TO_PATH[view]}
      onClick={onClick || (() => navigate(VIEW_TO_PATH[view]))}
      alert={alert}
    />
  );
}
